import {Component, OnInit} from '@angular/core';
import {AppNameEnum, OrganschaftsverhaeltnisseAngaben, OrgantraegerDetail, OrgantraegerDetailKapGAus} from '@nachdigal';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ComponentHelper, WizardListPageBaseComponent} from '@utils-lib';

@Component({
  selector: 'common-ui-organschaftsverhaeltnisse-angaben',
  templateUrl: './organschaftsverhaeltnisse-angaben.component.html',
  styleUrls: ['./organschaftsverhaeltnisse-angaben.component.scss']
})
export class OrganschaftsverhaeltnisseAngabenComponent extends WizardListPageBaseComponent<OrganschaftsverhaeltnisseAngaben>
  implements OnInit {

  static nutzdatenPath = 'organschaftsverhaeltnisseAngaben';
  static route = 'organschaftsverhaeltnisse-angaben';
  public selectedIndex = -1;
  public isKapGAus = false;

  constructor(protected readonly activatedRoute: ActivatedRoute,
              private readonly router: Router,
              private readonly translateService: TranslateService) {
    super(activatedRoute);
    this.maxAllowed = 2;
  }

  public ngOnInit(): void {
    super.ngOnInit();

    const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
    this.isKapGAus = appEnum === AppNameEnum.FragebogenKapGAus;

    if (history.state?.organtraeger) {
      this.data.organtraeger = history.state.organtraeger;
    }
    if (history.state?.konzern) {
      this.data.konzern = history.state.konzern;
    }
    if (history.state?.aufstellung) {
      this.data.aufstellung = history.state.aufstellung;
    }
    if (!this.data.organtraeger) {
      this.data.organtraeger = [];
    }
    if (this.isKapGAus) {
      if (!this.data.organtraegerKapGAus) {
        this.data.organtraegerKapGAus = [];
      }
      this.data.organtraegerKapGAus.forEach(entry => {
        if (entry.isKStUndGewStOrgangesellschaft === undefined) {
          entry.isKStUndGewStOrgangesellschaft = false;
        }
        if (entry.isUStOrgantraegerIdentisch === undefined) {
          entry.isUStOrgantraegerIdentisch = false;
        }
        if (entry.isUmsatzsteuerOrgangesellschaft === undefined) {
          entry.isUmsatzsteuerOrgangesellschaft = false;
        }
      });
    }
  }

  addOrgantraeger(): void {
    if (this.isKapGAus) {
      this.data.organtraegerKapGAus.push({
        isKStUndGewStOrgangesellschaft: false,
        isUStOrgantraegerIdentisch: false,
        isUmsatzsteuerOrgangesellschaft: false
      });
      this.selectedIndex = this.data.organtraegerKapGAus.length - 1;
    } else {
      this.data.organtraeger.push({ustIdentifikationsnummer: null});
      this.selectedIndex = this.data.organtraeger.length - 1;
    }
  }

  removeOrgantraeger(index: number): void {
    if (this.isKapGAus) {
      this.data.organtraegerKapGAus.splice(index, 1);
    } else {
      this.data.organtraeger.splice(index, 1);
    }
  }

  getDescription(organtraeger: OrgantraegerDetail | OrgantraegerDetailKapGAus): string {
    if (this.isKapGAus) {
      const kapgAusDetail = organtraeger as OrgantraegerDetailKapGAus;
      return kapgAusDetail?.nameOrgantraegerKSt
        || kapgAusDetail?.nameOrgantraegerUSt
        || this.translateService.instant('COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.NEW_ORGANTRAEGER');
    }
    const detail = organtraeger as OrgantraegerDetail;
    if (detail?.natuerlichePerson?.nachname && detail?.natuerlichePerson?.vorname) {
      return `${detail.natuerlichePerson.vorname} ${detail.natuerlichePerson.nachname}`;
    }
    if (detail?.juristischePerson?.nameOrgantraeger) {
      return `${detail.juristischePerson.nameOrgantraeger}`;
    }
    return this.translateService.instant('COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.NEW_ORGANTRAEGER');
  }

  protected getStammdatenMappingRules(): Map<string, unknown> {
    return new Map<string, unknown | Array<unknown>>();
  }

}
